import { useState, useEffect } from 'react';

// Draait deze code in de echte iOS/Android-app (Capacitor-schil uit de
// App Store / Play Store) of gewoon in de browser (ook op een telefoon)?
export const isNativeApp = () => {
  if (typeof window !== 'undefined' && window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function') {
    return window.Capacitor.isNativePlatform();
  }
  return false;
};

// Zelfde grens als de mobiele CSS van de dashboards (max-width: 768px).
const PHONE_QUERY = '(max-width: 768px)';

// App-weergave: het document zelf scrolt NIET (anders veert op iOS de hele pagina
// mee, inclusief de "vaste" onderste tabbalk). In plaats daarvan scrolt de
// container van het scherm (zie ".native-shell" in appTheme.css), waardoor de
// onderste tabbalk echt onbeweeglijk blijft.
export const useNativeShell = (active) => {
  useEffect(() => {
    if (!active || typeof document === 'undefined') return undefined;
    const root = document.documentElement;
    root.classList.add('native-shell');
    return () => root.classList.remove('native-shell');
  }, [active]);
};

// Scrolt de pagina terug naar boven: zowel het gewone document (computer) als de
// scrollende app-container (telefoon/app).
export const scrollPageToTop = (behavior = 'auto') => {
  if (typeof window === 'undefined') return;
  window.scrollTo({ top: 0, behavior });
  document
    .querySelectorAll('.dashboard-container-native, .cleaner-container-native, .admin-container-native')
    .forEach((el) => el.scrollTo({ top: 0, behavior }));
};

// Toon je de app-weergave (onderste tabbalk, geen hamburgermenu)? Ja in de echte
// app, en ook in de webapp op een telefoon (smal scherm), zodat die er precies
// hetzelfde uitziet en werkt als de app. Op computer/tablet is het de gewone
// weergave met navigatiebalk bovenaan.
export const useAppLayout = () => {
  const native = isNativeApp();
  const [narrow, setNarrow] = useState(() => (
    typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(PHONE_QUERY).matches
  ));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return undefined;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setNarrow(mq.matches);
    onChange();
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);

  return native || narrow;
};
